module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/GridItem4-01cef4ba66a3dcaf84e61974cd40eeb8.webp";